<template>
  <div class="page page-user">
    <div class="row">
      <div class="col">
        <h3>Пользователь</h3>
      </div>
      <div class="col">
        <ActionBar
          v-if="authedUser.roles['Администратор']"
          :isEditing="isEditing"
          @changeAction="changeUser"
          @cancelAction="cancelUserChanges"
          @deleteAction="deleteUser"
          @saveAction="updateUser"
        />
      </div>
    </div>
    <UserEdit v-if="isEditing" v-model="user" />
    <UserShow v-else :user="authedUser.id == userId ? authedUser : user" />
    <button
      v-if="authedUser.roles['Администратор']"
      class="btn btn-outline-danger"
      @click="newPassword"
    >Установить новый пароль</button>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import usersAPI from '@/api/users'
import deepAssign from 'assign-deep'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'UserPage',
  props: ['userId'],
  data () {
    return {
      isUpdating: false,
      prevUser: null,
      user: {},
      isEditing: false
    }
  },
  computed: {
    ...mapState('taxi/users', {
      authedUser: state => state.items.find(user => user.id === state.authedId)
    })
  },
  methods: {
    newPassword () {
      Swal.fire({
        title: 'Введите новый пароль',
        input: 'password',
        inputValidator: (value) => {
          if (!value) {
            return 'Пароль не может быть пустым!'
          }
        }
      }).then(password => {
        if (!password.dismiss) {
          usersAPI.resetPassword({ id: this.userId, password: password.value })
            .catch(text => {
              Swal.fire({
                icon: 'error',
                title: 'Ошибка',
                html: text.message
              })
            })
        }
      })
    },
    updateUser () {
      if (this.isUpdating) {
        return
      }
      this.isUpdating = true
      usersAPI.setUserRoles({
        id: this.user.id,
        roles: this.user.selectedRoles
      })
        .then(() => {
          usersAPI.updateItem(this.user)
            .then(user => {
              this.isEditing = false
              this.isUpdating = false
              this.user = user.model
              this.user.selectedRoles = Object.keys(this.user.roles)
              this.user.accessibleRoles = Object.values(this.user.accessibleRoles)
              if (this.user.id === this.authedUser.id) {
                this.loadAuthedUser()
              }
            })
            .catch(text => {
              this.isUpdating = false
              Swal.fire({
                icon: 'error',
                title: 'Ошибка',
                html: text.message
              })
            })
        })
        .catch(text => {
          this.isUpdating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    loadData () {
      usersAPI.getItem({ id: this.userId })
        .then(response => {
          this.user = response
          this.user.selectedRoles = Object.keys(this.user.roles)
          this.user.accessibleRoles = Object.values(this.user.accessibleRoles)
        })
    },
    changeUser () {
      this.prevUser = deepAssign({}, this.user)
      this.isEditing = true
    },
    cancelUserChanges () {
      this.user = this.prevUser
      this.isEditing = false
    },
    deleteUser () {
      usersAPI.removeItem(this.userId)
        .then(() => {
          this.$router.push('/users')
        })
        .catch(text => {
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    ...mapActions('taxi/users', [
      'loadAuthedUser'
    ])
  },
  watch: {
    userId: {
      immediate: true,
      handler () {
        this.loadAuthedUser()
        this.loadData()
      }
    }
  }
}
</script>
<style scoped>
  .page-user .btn-primary {
    width: 8rem;
    margin-left: 0.4rem;
    float: right !important;
  }
</style>
